import styled from "styled-components";

// Lets the link be positioned outside the field's own box, into the Row's gutter.
export const FieldColumnWithLink = styled.div`
    position: relative;
`;

export const EntityLinkIcon = styled.a`
    position: absolute;
    top: 50%;
    left: 100%;
    transform: translateY(calc(-50% - 12px));
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 20px;
    line-height: 1;
`;
